import React from 'react';
import { MapPin, Waves, TreePine } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const PousadaSection = ({ onOpenForm }) => {
  const amenities = [
    {
      title: 'Piscina',
      description: 'Piscina ampla para lazer e descanso',
      image: 'https://customer-assets.emergentagent.com/job_turismo-landing-ar/artifacts/dlqzjv2e_POUSADA%20VERDE%20MARES.jpeg'
    },
    {
      title: 'Área Externa',
      description: 'Jardim com palmeiras e área de convivência',
      image: 'https://customer-assets.emergentagent.com/job_turismo-landing-ar/artifacts/a00ke8wc_POUSADA%20VERDES%20MARES%20%282%29.jpeg'
    },
    {
      title: 'Lazer',
      description: 'Espaço completo para relaxar',
      image: 'https://customer-assets.emergentagent.com/job_turismo-landing-ar/artifacts/cbj2hixw_POUSADA%20VERDES%20MARES%20DA%20AGENCIA.jpeg'
    },
    {
      title: 'Estrutura',
      description: 'Ambiente acolhedor em meio à natureza',
      image: 'https://customer-assets.emergentagent.com/job_turismo-landing-ar/artifacts/lcjpbbbl_POUSADA%20VERDES%20MARES.jpeg'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-teal-100 text-teal-700 px-4 py-2 rounded-full mb-4">
            <Waves className="w-4 h-4" />
            <span className="font-semibold">Sua Hospedagem</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Pousada <span className="text-red-600">Verdes Mares</span> - Porto Seguro
          </h2>
          <div className="max-w-3xl mx-auto">
            <p className="text-xl text-gray-600 leading-relaxed mb-6">
              A Pousada Verdes Mares está localizada a aproximadamente <strong className="text-gray-900">300 metros 
              da praia de Coroa Vermelha</strong> e encanta pela beleza natural, estrutura aconchegante e 
              excelente custo-benefício para viagens em grupo.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-6 text-gray-700">
              <div className="flex items-center gap-2">
                <MapPin className="w-5 h-5 text-red-600" />
                <span className="font-semibold">Localização privilegiada</span>
              </div>
              <div className="flex items-center gap-2">
                <TreePine className="w-5 h-5 text-teal-600" />
                <span className="font-semibold">Ambiente tranquilo</span>
              </div>
              <div className="flex items-center gap-2">
                <Waves className="w-5 h-5 text-cyan-600" />
                <span className="font-semibold">Ideal para descanso e lazer</span>
              </div>
            </div>
          </div>
        </div>

        {/* Amenities Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {amenities.map((amenity, index) => (
            <Card 
              key={index}
              className="overflow-hidden border-none shadow-xl hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 group"
            >
              <div className="relative h-72 overflow-hidden">
                <img
                  src={amenity.image}
                  alt={amenity.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                  <h3 className="text-2xl font-bold mb-2">{amenity.title}</h3>
                  <p className="text-gray-200">{amenity.description}</p>
                </div>
              </div>
            </Card>
          ))}
        </div>

        {/* Bottom Info */}
        <div className="mt-12 text-center">
          <button
            onClick={onOpenForm}
            className="bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-8 rounded-full text-lg transition-all duration-300 hover:scale-105 shadow-xl animate-pulse-glow"
          >
            Consultar Disponibilidade
          </button>
        </div>
      </div>
    </section>
  );
};

export default PousadaSection;
